/*  ========================================================================
    # Scripts - Page Status
    ========================================================================  */

/**
 * Script that handles the accordion of the faq.
 */

const FAQ = {
  config: {
    questions: document.querySelectorAll('.s-faq__question')
  },

  initFAQAccordion() {
    this.config.questions.forEach(entry => {
      const header = entry.querySelector('.s-faq__question-header');
      header.addEventListener('click', () => {
        const text = header.nextElementSibling;
        const indicator = header.querySelector('.s-faq__question-indicator--1');
        if (text.style.maxHeight) {
          text.style.maxHeight = null;
          indicator.style.transform = 'rotate(90deg)';
        } else {
          text.style.maxHeight = text.scrollHeight + 'px';
          indicator.style.transform = 'rotate(0)';
        }
      });
    });
  },

  init() {
    this.initFAQAccordion();
  }
};

export default FAQ;
